export default __webpack_public_path__ + "static/media/aero-syringe.ed9e40ac.jpg";